import Hero from "../sections/hero";
import AboutPage from "../sections/aboutPage";
import Footer from "../sections/footer";

function About() {
  return (
    <div>
      <Hero heroImg={"aboutHero"} title={"PERFECTION ISN’T AN AIM, IT’S A DEMAND"} />
      <AboutPage />
      <Footer />
    </div>
  );
}

export default About;
